<template>
	<div class="row">
		<div class="col-sm-12 col-md-12 col-lg-12">
			<div class="login reset-password" style="margin: 12% 0">
				<div class="row row-form">
					<div class="col-sm-12">
						<template v-if="mode === 'reset'">
							<p class="login_description">{{ $t('password.is.reset') }}</p>

							<div class="login_home_link">
								<div class="row">
									<div class="col-xs-7">
										<a class="auth-link" href="/">{{ $t('back') }}</a>
									</div>
									<div class="col-xs-5">
										<Languages/>
									</div>
								</div>
							</div>
						</template>
						<template v-else-if="mode === 'error'">

						</template>
						<template v-else-if="mode === 'set-password'">
							<input class="textInput login_input-top-radius"
								   name="password"
								   type="password"
								   id="login_input-new-pass"
								   :placeholder="$t('password')"
								   v-model="password">
							<input class="textInput login_input-bottom-radius"
								   type="password"
								   id="login_input-pass-confirmation"
								   :placeholder="$t('confirmation')"
								   v-model="confirmPassword">
							<button type="submit" @click="setPassword" class="login_button-login" id="login_change-password-button">
								{{ $t('change.password') }}</button>

							<div class="login_home_link">
								<div class="row">
									<div class="col-xs-7">
										<a class="auth-link" href="/">{{ $t('back') }}</a>
									</div>
									<div class="col-xs-5">
										<Languages/>
									</div>
								</div>
							</div>
						</template>
						<template v-else>
							<input class="textInput login_input-full-radius" name="username" v-model="email" type="text"
								   id="login_input-name" :placeholder="$t('email')">
							<p v-if="error === 'not-found-user'" class="login_error">{{ $t('not.found.user') }}</p>
							<button type="submit" @click="resetPassword" class="login_button-login">{{ $t('reset.password') }}
							</button>

							<div class="login_home_link">
								<div class="row">
									<div class="col-xs-7">
										<a class="auth-link" href="/">{{ $t('back') }}</a>
									</div>
									<div class="col-xs-5">
										<Languages/>
									</div>
								</div>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import http from 'utils/http'
import Languages from 'components/languages-switch/Languages'
import { checkPassword } from '@/core/shared'

export default {
	name: 'ResetPassword',
	metaInfo: {
		title: 'Reset password'
	},
	data() {
		return {
			email: '',
			error: '',
			password: '',
			confirmPassword: ''
		}
	},
	props: [
		'mode',
		'token'
	],
	components: {
		Languages
	},
	methods: {
		resetPassword: function () {
			http.post('/password/reset', {}, {
				params: {
					username: this.email
				},
			})
				.then((resp) => {
					this.$router.push({ path: 'reset-password', query: { mode: 'reset'}})
				})
			.catch(error => {
				this.error = 'not-found-user'
				console.log(error)
			})
		},
		setPassword: function () {
			if (checkPassword(this.password, this.confirmPassword)) {
				http.post('/password/reset', {}, {
					params: {
						token: this.token,
						password: this.password
					},
				})
					.then((resp) => {
						this.$router.push({ path: '/'})
					})
					.catch(error => {
						this.error = error.data
						console.log(error)
					})
			}
		}
	}
}
</script>

<style scoped>

</style>
